import Record from "slotworks/model/gameplay/records/record";

export default class SpinRecord extends Record {

    /** ID for debugging purposes */
    public id: string = "SpinRecord";

    public reelset: string[][];

    /**
     * 2D array where each inner array is a reel
     */
    public grid: string[][];
    public overlayGrid: string[][];

    public stops: number[];
}
